/**
 * Add to Cart button price sync
 *
 * The button's price (current + struck-through compare-at) is rendered
 * server-side by Liquid using the selected variant's price, so it always
 * shows something - independent of whether a visible price block exists
 * elsewhere on the page.
 *
 * This script's only job is to override that default with the live
 * Bundlex "Bundle & Save" price whenever the shopper has an active
 * bundle offer with a real discount selected, and to revert back to the
 * default price otherwise (e.g. they pick the single, non-bundle offer).
 *
 * Bundlex markup relied on:
 *   .bx-widget-container
 *     .bx-offer-wrap[aria-checked="true"]                     -> active offer
 *       .bx-offer-prices .bx-original-price .transcy-money    -> full price
 *       .bx-offer-prices .bx-discounted-price .transcy-money  -> discounted price
 *
 * If Bundlex renames these classes, this script just stops overriding
 * the default price (fails safe) rather than breaking anything.
 */
(function () {
  'use strict';

  var BUNDLE_WIDGET_SELECTOR = '.bx-widget-container';
  var BUNDLE_ACTIVE_OFFER_SELECTOR = '.bx-offer-wrap[aria-checked="true"], .bx-offer-wrap.bx-active';

  // Guards against apps (e.g. a currency-conversion widget) that leave
  // literal HTML characters sitting as text inside the price element.
  // Strips any tag-like fragments rather than just rejecting the value,
  // since Bundlex's own price nodes may be touched by the same app.
  function sanitizePriceText(text) {
    if (!text) return '';
    var cleaned = text.replace(/<[^>]*>/g, '').trim();
    if (!/\d/.test(cleaned)) return '';
    if (cleaned.length > 40) return '';
    return cleaned;
  }

  function getBundlePrices() {
    var widget = document.querySelector(BUNDLE_WIDGET_SELECTOR);
    if (!widget) return null;

    var activeOffer = widget.querySelector(BUNDLE_ACTIVE_OFFER_SELECTOR);
    if (!activeOffer) return null;

    var discountedEl = activeOffer.querySelector('.bx-discounted-price .transcy-money, .bx-discounted-price');
    var originalEl = activeOffer.querySelector('.bx-original-price .transcy-money, .bx-original-price');

    var discounted = sanitizePriceText(discountedEl ? discountedEl.textContent : '');
    var original = sanitizePriceText(originalEl ? originalEl.textContent : '');

    // Only a valid override if there's an actual discount. Otherwise let
    // the caller fall back to the default server-rendered price.
    if (!discounted || !original || discounted === original) return null;

    return { current: discounted, compare: original };
  }

  function updateButtonPrice(priceWrap) {
    var currentEl = priceWrap.querySelector('[data-bundle-price-current]');
    var compareEl = priceWrap.querySelector('[data-bundle-price-compare]');
    if (!currentEl || !compareEl) return;

    var bundlePrices = getBundlePrices();

    var current = bundlePrices ? bundlePrices.current : priceWrap.dataset.defaultCurrent;
    var compare = bundlePrices ? bundlePrices.compare : priceWrap.dataset.defaultCompare;

    if (!current) {
      priceWrap.hidden = true;
      return;
    }

    currentEl.textContent = current;

    if (compare) {
      compareEl.textContent = compare;
      compareEl.hidden = false;
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }

    priceWrap.hidden = false;
  }

  function initForForm(form) {
    if (form.dataset.bundlePriceBound) return;
    form.dataset.bundlePriceBound = 'true';

    var priceWrap = form.querySelector('[data-bundle-price]');
    if (!priceWrap) return;

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        updateButtonPrice(priceWrap);
      });
    }

    // Default price is already correct on first paint (server-rendered).
    // These extra calls only matter for catching an asynchronously
    // injected Bundlex widget.
    schedule();
    setTimeout(schedule, 800);
    setTimeout(schedule, 2000);
    setTimeout(schedule, 4000);

    // Watch for Bundlex offer changes (selection + live price text updates).
    var observer = new MutationObserver(function () {
      schedule();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-checked', 'class'],
      characterData: true
    });
  }

  function init() {
    var forms = document.querySelectorAll('product-form .product-form, form[data-type="add-to-cart-form"]');
    forms.forEach(function (form) {
      initForForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();